import { COLORS } from "@themes";
import React from "react";
import styled from "styled-components";


export const StyledHeadingText = styled.span`
  color: var(--background-foreground, #001023);
  font-size: 24px;
  font-family: Poppins;
  font-weight: 600;
  line-height: 32px;
  word-wrap: break-word;
`;

export const StyledHeading = styled.p`
  align-self: stretch;
  text-align: center;
`;

export const StyledDescriptionText = styled.span`
  color: var(--muted-muted-foreground, #3A405F);
  font-size: 18px;
  font-family: Poppins;
  font-weight: 400;
  line-height: 24px;
  word-wrap: break-word;
`;

export const StyledDescription = styled.p`
  align-self: stretch;
  opacity: 0.75;
  text-align: center;
`;

export const StyledVector = styled.div`
  width: 14.33px;
  height: 14.33px;
  left: 0.83px;
  top: 0.83px;
  position: absolute;
  background: var(--primary-primary, #036FFC);
`;

export const StyledPhoneLinkText = styled.span`
  color: var(--primary-primary, #036FFC);
  font-size: 18px;
  font-family: Poppins;
  font-weight: 400;
  line-height: 24px;
  word-wrap: break-word;
`;

export const StyledPhoneLink = styled.p`
  text-align: center;
`;

export const StyledMailIcon = styled.img`
  width: 20px;
  height: 20px;
`;

export const StyledPhoneIcon = styled.img`
  width: 20px;
  height: 20px;
`;

export const StyledEmailLinkText = styled.span`
  color: var(--primary-primary, #036FFC);
  font-size: 18px;
  font-family: Poppins;
  font-weight: 400;
  line-height: 24px;
  word-wrap: break-word;
`;

export const StyledEmailLink = styled.p`
  text-align: center;
`;

export const StyledTitle = styled.div`
  width: 100%;
  max-width: 600px;
  min-width: 300px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  display: flex;
`;

export const StyledIconWrapper = styled.div`
  width: 20px;
  height: 20px;
  position: relative;
  overflow: hidden;
`;

export const StyledPhoneNo = styled.div`
  min-height: 40px;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
  background: var(--unofficial-ghost, rgba(255, 255, 255, 0));
  border-radius: 4px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  display: flex;
`;

export const StyledEmail = styled.div`
  min-height: 40px;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
  background: var(--unofficial-ghost, rgba(255, 255, 255, 0));
  border-radius: 4px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  display: flex;
`;

export const StyledTextGroup = styled.div`
  justify-content: flex-start;
  align-items: flex-start;
  display: inline-flex;
`;

export const StyledSection = styled.div`
  align-self: stretch;
  width: 100%;
  height: 100%;
  min-height: 700px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  display: flex;
  background-color: ${COLORS.WHITE_1};
  min-height: calc(100vh - 70px);
`;
